import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'item-status',
	templateUrl: './item-status.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ItemStatusComponent implements OnInit {
	
	@Input() hasBorder: any | undefined;
	@Input() status: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		
	}
	
}